module.exports = __webpack_public_path__ + "img/aspect-ratio-icon.5e2f8477.svg";